import { create, StoreApi } from 'zustand';

interface AuthState {
  token: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  isInitialized: boolean;
  setTokens: (token: string, refreshToken?: string) => void;
  setToken: (token: string) => void;
  updateToken: (token: string) => void;
  setInitialized: (value: boolean) => void;
  logout: () => void;
}

type SetState = StoreApi<AuthState>['setState'];

export const useAuthStore = create<AuthState>((set: SetState) => ({
  token: null,
  refreshToken: null,
  isAuthenticated: false,
  isInitialized: false,

  setTokens: (token: string, refreshToken?: string) =>
    set({
      token,
      refreshToken: refreshToken || null,
      isAuthenticated: true
    }),

  setToken: (token: string) =>
    set({
      token,
      isAuthenticated: true
    }),

  updateToken: (token: string) =>
    set((state: AuthState) => ({
      ...state,
      token
    })),

  setInitialized: (value: boolean) =>
    set({ isInitialized: value }),

  logout: () =>
    set({
      token: null,
      refreshToken: null,
      isAuthenticated: false
    }),
}));
